const ARMarkers = {
    QR: {
        isDefault: true,
        name: "marker_qr",
        alias: "ARMarkers/QR",
        type: "ARMarker",
        markerType: "qr",
    },
    Hiro: {
        isDefault: true,
        name: "marker_hiro",
        alias: "ARMarkers/Hiro",
        type: "ARMarker",
        markerType: "hiro",
    },
    Alignment: {
        isDefault: true,
        name: "marker_alignment",
        alias: "ARMarkers/Alignment",
        type: "ARMarker",
        markerType: "alignment",
    },
};

module.exports = {
    ARMarkers
};